import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/user-20.jpg'
import _imports_1 from '@/assets/images/user-21.jpg'
import _imports_2 from '@/assets/images/user-22.jpg'
import _imports_3 from '@/assets/images/user-23.jpg'
import _imports_4 from '@/assets/images/user-24.jpg'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "card-body p-0 pb-4" }, [
      _createElementVNode("div", { class: "p-4" }, [
        _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3" }, [
          _createElementVNode("h3", { class: "mb-0" }, "Team Members"),
          _createElementVNode("div", { class: "dropdown action-opt" }, [
            _createElementVNode("button", {
              class: "btn bg-transparent p-0",
              type: "button",
              "data-bs-toggle": "dropdown",
              "aria-expanded": "false"
            }, [
              _createElementVNode("i", { "data-feather": "more-horizontal" })
            ]),
            _createElementVNode("ul", { class: "dropdown-menu dropdown-menu-end bg-white border box-shadow" }, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "javascript:;"
                }, [
                  _createElementVNode("i", { "data-feather": "clock" }),
                  _createTextVNode(" Today ")
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "javascript:;"
                }, [
                  _createElementVNode("i", { "data-feather": "pie-chart" }),
                  _createTextVNode(" Last 7 Days ")
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "javascript:;"
                }, [
                  _createElementVNode("i", { "data-feather": "rotate-cw" }),
                  _createTextVNode(" Last Month ")
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "javascript:;"
                }, [
                  _createElementVNode("i", { "data-feather": "calendar" }),
                  _createTextVNode(" Last 1 Year ")
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "javascript:;"
                }, [
                  _createElementVNode("i", { "data-feather": "bar-chart" }),
                  _createTextVNode(" All Time ")
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "javascript:;"
                }, [
                  _createElementVNode("i", { "data-feather": "eye" }),
                  _createTextVNode(" View ")
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  href: "javascript:;"
                }, [
                  _createElementVNode("i", { "data-feather": "trash" }),
                  _createTextVNode(" Delete ")
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", { class: "default-table-area style-two team-members" }, [
        _createElementVNode("div", { class: "table-responsive" }, [
          _createElementVNode("table", { class: "table align-middle border-0" }, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, "Name"),
                _createElementVNode("th", { scope: "col" }, "Tasks"),
                _createElementVNode("th", { scope: "col" }, "Status")
              ])
            ]),
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", { class: "border-0 py-3 pb-0" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "flex-shrink-0" }, [
                      _createElementVNode("img", {
                        src: _imports_0,
                        class: "wh-44 rounded-circle",
                        alt: "user"
                      })
                    ]),
                    _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                      _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Olivia Clark"),
                      _createElementVNode("span", { class: "fs-12" }, "Head of HR")
                    ])
                  ])
                ]),
                _createElementVNode("td", { class: "border-0 py-3 pb-0" }, "55"),
                _createElementVNode("td", { class: "border-0 py-3 pb-0" }, [
                  _createElementVNode("div", {
                    class: "progress bg-opacity-10 bg-primary",
                    role: "progressbar",
                    "aria-label": "Example with label",
                    "aria-valuenow": "50",
                    "aria-valuemin": "0",
                    "aria-valuemax": "100",
                    style: {"height":"5px"}
                  }, [
                    _createElementVNode("div", {
                      class: "progress-bar rounded-pill",
                      style: {"width":"50%","height":"5px"}
                    })
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", { class: "border-0 py-3 pb-0" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "flex-shrink-0" }, [
                      _createElementVNode("img", {
                        src: _imports_1,
                        class: "wh-44 rounded-circle",
                        alt: "user"
                      })
                    ]),
                    _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                      _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Alexander Garcia"),
                      _createElementVNode("span", { class: "fs-12" }, "Product Manager")
                    ])
                  ])
                ]),
                _createElementVNode("td", { class: "border-0 py-3 pb-0" }, "125"),
                _createElementVNode("td", { class: "border-0 py-3 pb-0" }, [
                  _createElementVNode("div", {
                    class: "progress bg-opacity-10 bg-success",
                    role: "progressbar",
                    "aria-label": "Example with label",
                    "aria-valuenow": "50",
                    "aria-valuemin": "0",
                    "aria-valuemax": "100",
                    style: {"height":"5px"}
                  }, [
                    _createElementVNode("div", {
                      class: "progress-bar bg-success rounded-pill",
                      style: {"width":"50%","height":"5px"}
                    })
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", { class: "border-0 py-3 pb-0" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "flex-shrink-0" }, [
                      _createElementVNode("img", {
                        src: _imports_2,
                        class: "wh-44 rounded-circle",
                        alt: "user"
                      })
                    ]),
                    _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                      _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Chloe Lewis"),
                      _createElementVNode("span", { class: "fs-12" }, "UX/UI Designer")
                    ])
                  ])
                ]),
                _createElementVNode("td", { class: "border-0 py-3 pb-0" }, "78"),
                _createElementVNode("td", { class: "border-0 py-3 pb-0" }, [
                  _createElementVNode("div", {
                    class: "progress bg-opacity-10 bg-primary-div",
                    role: "progressbar",
                    "aria-label": "Example with label",
                    "aria-valuenow": "50",
                    "aria-valuemin": "0",
                    "aria-valuemax": "100",
                    style: {"height":"5px"}
                  }, [
                    _createElementVNode("div", {
                      class: "progress-bar rounded-pill bg-primary-div",
                      style: {"width":"50%","height":"5px"}
                    })
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", { class: "border-0 py-3 pb-0" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "flex-shrink-0" }, [
                      _createElementVNode("img", {
                        src: _imports_3,
                        class: "wh-44 rounded-circle",
                        alt: "user"
                      })
                    ]),
                    _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                      _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Ava Turner"),
                      _createElementVNode("span", { class: "fs-12" }, "Python Developer")
                    ])
                  ])
                ]),
                _createElementVNode("td", { class: "border-0 py-3 pb-0" }, "95"),
                _createElementVNode("td", { class: "border-0 py-3 pb-0" }, [
                  _createElementVNode("div", {
                    class: "progress bg-opacity-10 bg-danger",
                    role: "progressbar",
                    "aria-label": "Example with label",
                    "aria-valuenow": "50",
                    "aria-valuemin": "0",
                    "aria-valuemax": "100",
                    style: {"height":"5px"}
                  }, [
                    _createElementVNode("div", {
                      class: "progress-bar bg-danger rounded-pill",
                      style: {"width":"50%","height":"5px"}
                    })
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", { class: "border-0 py-3 pb-0" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center" }, [
                    _createElementVNode("div", { class: "flex-shrink-0" }, [
                      _createElementVNode("img", {
                        src: _imports_4,
                        class: "wh-44 rounded-circle",
                        alt: "user"
                      })
                    ]),
                    _createElementVNode("div", { class: "flex-grow-1 ms-2 position-relative top-2" }, [
                      _createElementVNode("h6", { class: "mb-0 fs-14 fw-medium" }, "Ryan Flores"),
                      _createElementVNode("span", { class: "fs-12" }, "WP Developer")
                    ])
                  ])
                ]),
                _createElementVNode("td", { class: "border-0 py-3 pb-0" }, "134"),
                _createElementVNode("td", { class: "border-0 py-3 pb-0" }, [
                  _createElementVNode("div", {
                    class: "progress bg-opacity-10 bg-primary",
                    role: "progressbar",
                    "aria-label": "Example with label",
                    "aria-valuenow": "50",
                    "aria-valuemin": "0",
                    "aria-valuemax": "100",
                    style: {"height":"5px"}
                  }, [
                    _createElementVNode("div", {
                      class: "progress-bar rounded-pill",
                      style: {"width":"50%","height":"5px"}
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ])))
}